import { useCallback } from 'react';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { useShowNotification } from 'js/components/common/Notifications';

import * as server from './server';
import * as actions from '../../store/actions';
import { useDynamicReducerDispatch } from '../../store';

export const useOnSubmit = ({ setError, translate }) => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const showNotification = useShowNotification();
    const getErrorMessage = useGetErrorMessage();

    return useCallback(async ({ limit: withdrawThreshold, amountToBeLeftOnBalance: minBalanceLimit }, form) => {
        if (!isMounted()) {
            return;
        }

        setError('');

        try {
            await server.setAutomaticWithdrawLimits({ minBalanceLimit, withdrawThreshold });

            isMounted() && dispatch(actions.toggleLoading(true));
            showNotification({ iconType: 'info', message: translate('save.success') });

            form.restart();
        } catch (error) {
            const errorMsg = getErrorMessage(error);

            isMounted() && setError(errorMsg);
        }
    }, [
        setError,
        dispatch,
        isMounted,
        translate,
        getErrorMessage,
        showNotification
    ]);
};
